import React from 'react';
import { FileText } from 'lucide-react';
import type { Attachment } from '../../types';

interface AttachmentPreviewProps {
  attachment: Attachment;
}

const AttachmentPreview = React.memo(function AttachmentPreview({
  attachment,
}: AttachmentPreviewProps) {
  return (
    <div className="mt-2 text-xs text-gray-600 flex items-center gap-2">
      {attachment.previewUrl ? (
        <img
          src={attachment.previewUrl}
          alt={attachment.name}
          className="w-16 h-16 object-cover rounded border"
          loading="lazy"
          decoding="async"
        />
      ) : (
        <FileText className="w-4 h-4" aria-hidden="true" />
      )}
      <span>{attachment.name}</span>
    </div>
  );
});

export default AttachmentPreview;
